export default __webpack_public_path__ + "static/media/BG_Page_03.6d67f154.svg";